import { Injectable, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

export const SITE_TITLE = 'MPACT';

/**
 * Sets the browser title (and og:title) on every navigation: "MPACT – <route title>"
 * when the route defines a `title`, otherwise plain "MPACT". This stops pages without
 * their own title from keeping the previous page's title. Components that call Title.setTitle()
 * themselves still override this, since they run after the router has set the default.
 */
@Injectable({ providedIn: 'root' })
export class MpactTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);
    const pageTitle = routeTitle ? `${SITE_TITLE} – ${routeTitle}` : SITE_TITLE;
    this.title.setTitle(pageTitle);
    this.meta.updateTag({ property: 'og:title', content: pageTitle }, `property='og:title'`);
  }
}
